declare var isMobile: boolean;
declare var canSendUpdate: boolean;
declare var bsiRecalcVat: string;
declare var PageAction: string;
declare var urlLangPrefBasket: string;
declare var GA4Scripts : {};

declare function saveadress(type: string, val: string, con: string, elem: object): void;
declare function BindInputCount(type: object): void;
declare function InitInputValidation(type: string): void;
declare function OffInputValidation(type: string): void;
declare function InputValidationCheck(type: object): boolean;
declare function InputValidationStateSet(wrap: object, type: string): void
declare function AT_OrderXhrPoolAbortAll(): void
declare function GA4BasketRemove(type: any): void;
declare function GA4BasketUpd(productData: any, event: any, quantity: any): void;

declare function basketItemDelete(basketFormId: string): void;

var $hBasketAjaxReload = null;
var $hBasketGift = null;
var $hBasketPayDelivery = null;
var $hBasketServices = null;
var $hBasketCoupons = null;
var $hBasketSum = null;
var $forceDelPayActualize = false;
var $vatPayer = null;
//jednokrok?
var $BasketFullPage = '0';
var $actualizeBasketRequest = null;

function processBasketJsonDelete(idRow: string, res: any): void {

    if (res.Items.length === 0) {
        window.location.href = window.location.href;
    }

    //smazu radek s produktem
    $('.productBasket__items--item[data-row="' + idRow + '"]').parents('.productBasket__itemsInner').remove();
    $('.productModal__items--item[data-basket-row="' + idRow + '"]').remove();
    $('#basketBoxLite .badge.modalSS__open').html(res.Items.length);

    processBasketJson(res);
}

//function basketItemDelete(basketFormId: string): void {
//    const code = $(basketFormId).data("ga-code");
//    $(basketFormId).find("input[name=delete][type=hidden]").val("1");

     
//    var idRow = $(basketFormId).find('input[name="idBasketItem"]').val();
//    var isSecondVat = ($(basketFormId).find('input[name="secondVat"]').length > 0);
//    var data = { code: $(basketFormId).find('input[name="code"]').val(), pkunit: $(basketFormId).find('input[name="unit"]').val(), fkTblCommodity: $(basketFormId).find('input[name="iditem"]').val(), Attribute: $(basketFormId).find('input[name="attribute"]').val(), secondVat: isSecondVat };

//    preloader(true);
//    EshopService("BasketItemDelete", data, false, function (result) {
//        preloader(false);
//        if (result.ErrorLevel == 0) {
//            var ga4data = GA4Scripts["g" + $(basketFormId).find('input[name="iditem"]').val()];
//            GA4BasketRemove(jQuery.parseJSON(ga4data));

//            var res = jQuery.parseJSON(result.Message);
//            if (res.Items.length === 0) {
//                window.location.href = window.location.href;
//            }

//            //smazu radek s produktem
//            $('.productBasket__items--item[data-row="' + idRow + '"]').parents('.productBasket__itemsInner').remove();
//            $('.productModal__items--item[data-basket-row="' + idRow + '"]').remove();
//            $('#basketBoxLite .badge.modalSS__open').html(res.Items.length);

//            if (typeof processBasketJson == 'function') { processBasketJson(res); }
//        }
//        else {
//            fancyMessage(GetTextDynamic("askme_form_error"), GetTextDynamic("js_error"), "error");
//        }

//    });

//}


function globalRunOnBasket() {
    $BasketFullPage = '1';
    globalRunOnBasket1();
    globalRunOnBasket2();
    globalRunOnBasket3();
}

function OnChangeCount(self, count) {
    self.prop("readonly", "true");

    if (count > 0) {

        var minAmount = Math.round(self.parents("form").find("input[name=minAmount]").val().replace(',', '.') * 1);
        if (count < minAmount) {
            self.removeAttr("readonly");
            self.val(minAmount);

            var sText = GetTextDynamic("commodity_min");
            // @ts-ignore
            $.fancybox.open("<h3 class='alert'>" + sText.replace("#min#", minAmount.toString()) + "<button data-fancybox-close='' class='fancybox-close-small' title='Close'></button></h3>", { 'autoSize': false, 'width': 500, "height": 150 });

            return;
        }
        actualizeBasket('change', self);
    }
    else {
        self.removeAttr("readonly");
        self.parents('.productBasket__items--item').find("button[name=delete]").trigger("click");
    }
}
function actualizeBasket(type, item) {

    var f = $(item).parents('form')
    var prms = $(f).serialize() + (lang.length > 0 ? "&lang=" + lang : "");

    if ($vatPayer != null && $BasketFullPage == '1') {
        prms = prms + "&setVAT=" + $vatPayer;
    }

    var url = "/ajax/basket.aspx?OneStep=" + $BasketFullPage;

    // Zahoď předchozí nedokončené requesty
    if ($actualizeBasketRequest != null) {
        $actualizeBasketRequest.abort();
        $actualizeBasketRequest = null;
    }


    $actualizeBasketRequest = $.ajax({
        type: "POST", cache: false, url: url, data: prms,
        success: function (data) {

            $(item).removeAttr("readonly");
            try {
                var res = jQuery.parseJSON(data);
                processBasketJson(res);
                $(f).find('input[name="oldCount"]').val($(f).find('input[name="count"]').val());
                //debugger;

            }
            catch (err) {
                console.log(err);
            }

        },
        complete: function () {
            preloader(false);
            $actualizeBasketRequest = null;
        },
        error: function (jqXHR, textStatus) {
            preloader(false);
            if (textStatus !== 'abort') {
                $(item).removeAttr("readonly");
            }
            $actualizeBasketRequest = null;
        }
    });
}

function refreshBasket(vatPayer) {

    var prms = "&getjson=1" + (lang.length > 0 ? "&lang=" + lang : "");
    if (!(typeof vatPayer === "undefined" || vatPayer === null)) {
        $vatPayer = (vatPayer ? "1" : "0");
        prms = prms + "&setVAT=" + (vatPayer ? "1" : "0");
    }

    var url = "/ajax/basket.aspx?OneStep=" + $BasketFullPage + "&refresh=1";
    var request = $.ajax({
        type: "POST", cache: false, url: url, data: prms,
        success: function (data) {

            try {
                var res = jQuery.parseJSON(data);
                processBasketJson(res);
            }
            catch (err) {
                console.log(err);
            }

        },
        complete: function () {
            preloader(false);
        },
        error: function () {
            preloader(false);
        }
    });
}

function pocessBasketItemMessageRow(row, json) {
    $(row).find('.item--info .info').each(function (i) { $(this).remove(); });
    if (json.InfoHtml != '')
        $(row).find('.item--info').append(json.InfoHtml);
}
function processBasketJson(json) {
    if (json.BasketState == "updated" || json.BasketState == "updatedwithchange" || json.BasketState == "deleted" || json.BasketState == "savedelivery" || json.BasketState == "refresh") {
        processBasketCommodityItems(json);
        processBasketCommodityGiftItems(json);
        processBasketCommodityCouponItem(json);
        processBasketGA4(json);
        //celkova cena zbozi
        $('#pricefullitems').html(json.sPriceSumWithVatWithoutDeliveryPayment);

        InsertFirstAndSecond($('#basketBoxLite .hi__basket--price'), json.sPriceSumWithVatWithoutDeliveryPayment, json.sPriceSumWithVatWithoutDeliveryPaymentSECOND);
        InsertFirstAndSecond($('#basketBoxLite .basketBox__prices--item .full-value'), json.sPriceSumWithVatWithoutDeliveryPayment, json.sPriceSumWithVatWithoutDeliveryPaymentSECOND);
          
        if (json.Coupon == null) {
            $('#basketBoxLite .basketBox__prices--item.discountcoupon').addClass('hidden');
            InsertFirstAndSecond($('#basketBoxLite .basketBox__prices--item.discountcoupon'), '', ''); 
        }
        else { 
            InsertFirstAndSecond($('#basketBoxLite .basketBox__prices--item.discountcoupon'), json.Coupon.sPriceWithVatSum, json.Coupon.sPriceWithVatSumSECOND); 
            $('#basketBoxLite .basketBox__prices--item.discountcoupon').removeClass('hidden');
        }
             
        processBasketCommoditySum(json);
        processBasketSumContent(json);
        if (typeof processBasketDeliveryPayment == 'function') { processBasketDeliveryPayment(json); }

        //z kroku adresy - zobraz/skryj dodaci adresy dle zvolene dopravy
        if (typeof SetAddressFieldsByDelivery == 'function') { SetAddressFieldsByDelivery(); }

        //celkova cena kosiku 
        InsertFirstAndSecond($('#basketBoxLite .basketBox__prices--item.item--total .item-value'), json.sPriceSumWithVat, json.sPriceSumWithVatSECOND); 
      
        $('.basketBox-content .delivery-free-wrap').html(json.DeliveyProgressBar);

        if ($BasketFullPage == '1' && json.Delivery != null && $('#hSelDelWithoutAddress').length > 0) {
            $('#hSelDelWithoutAddress').val(json.Delivery.DeliveryWithoutAddress ? "1" : "0");
        }

    }

    //akce kolem kuponu
    if (json.CouponVerifyResultCode != 0) {
        //chyba - vykreslim hlaseni
        if (json.CouponVerifyResultCode < 0) {

            //existuje kupon  = resim chyby  v radku 2
            if (json.CouponBasketCode != '') {
                $('#basketCouponBlock .line2 .alert-input.other').html(json.CouponVerifyResultMessage).removeClass('hidden');
            }
            else {
                $('#coupFrm .alert-input.other').html(json.CouponVerifyResultMessage);
                InputValidationStateSet($('#coupFrm .line1'), 'other');
            }
        }
        else if (json.CouponVerifyResultCode == 2 || json.CouponVerifyResultCode == 1) //uspesne vlozeni
        {
            if (json.CouponBasketCode != '') {
                $('.productBasket__info--coupon').addClass('exists'); //indikace ze je kupon -  toto zajisti ze se objevi druhy radek na kterem je nutno nastavit kod kuponu
                $('.productBasket__info--coupon .remove_coupon').html(json.CouponBasketCode);

            }
        }
        else if (json.CouponVerifyResultCode == 3 || json.CouponVerifyResultCode == 4) //odebrani kuponu
        {
            $('.productBasket__info--coupon').removeClass('exists');
            $('.productBasket__info--coupon .remove_coupon').html('');

            if (json.CouponVerifyResultCode == 4) //odebrani kuponu vnejsi vliv -> // pouha aktualizace polozek kosiku take muze neprimo ovlivnit kupon -> koupon byl v kosiku - zmenily se pravidla a je nutno overit zda na strance neni pozustatek....
            {
                $('#coupFrm .alert-input.other').html(json.CouponVerifyResultMessage);
                InputValidationStateSet($('#coupFrm .line1'), 'other');
            }
        }
    }
 

}

//polozky kosiku
function processBasketCommodityItems(json) {
    // if ($('.productBasket__items--item.product').length === 0) return;

    var items = json.Items;
    $(items).each(function (i, val) {
        var idRow = items[i].Id;
        var row = $('.productBasket__items--item.product[data-row="' + idRow + '"]');
        if (row != null) {
            InsertFirstAndSecond(row.find('.item--price'), items[i].sPriceWithVatSum, items[i].sPriceWithVatSumSECOND);

            var fp = " <span class='first-prc'>" + items[i].sPriceWithVat + "</span>"; 
            var sp = items[i].sPriceWithVatSECOND != "" ? "<span class='second-prc'>" + items[i].sPriceWithVatSECOND + "</span>" : "";
             
           row.find('.link-price').html(fp + sp + "<span class='slash -with-space'>&nbsp;/&nbsp;</span>" + items[i].Unit);

          // row.find('.link-price').html(" <span class='first-prc'>" + items[i].sPriceWithVat + "</span><span class='slash -with-space'>&nbsp;/&nbsp;</span>" + items[i].Unit);


            pocessBasketItemMessageRow(row, items[i]);
        }
        InsertFirstAndSecond($('#basketBoxLite .productModal__items--item[data-basket-row="' + idRow + '"] .prices__total'), items[i].sPriceWithVatSum, items[i].sPriceWithVatSumSECOND);
        InsertFirstAndSecond($('#basketBoxLite .productModal__items--item[data-basket-row="' + idRow + '"] .prices__perUnit'), items[i].sPriceWithVat, items[i].sPriceWithVatSECOND); 
        $('#basketBoxLite .productModal__items--item[data-basket-row="' + idRow + '"] .item-name').html(items[i].Count + "× " + items[i].Name);

        pocessBasketItemCoupledRow(items[i]);
    });
}

function pocessBasketItemCoupledRow(json) {
    if (json.CoupledItem == null) return false;
    var selector = '#cc-' + json.CoupledItem.IdParent;
    var content = json.CoupledItem.Count + json.CoupledItem.Unit;
    if ($(selector).length)
        $(selector).html(content);
}

function processBasketCommodityGiftItems(json) {
    if ($('.productBasket__items--item.product').length === 0) return;

    var items = json.Gifts;
    var langIdB = json.LangId;

    if (items == null || items.length === 0) {
        if ($('.gift__row').length > 0) $('.gift__row').remove();
    }
    else {
        var giftCodes = "";
        $(items).each(function (i, val) {
            giftCodes += "|" + items[i].Code + "|";
            ProcessBasketRowGift(langIdB, items[i]);
        });
        //pro jistotu odmazu ty radky, ktere nejsou v json
        var CodesToRemove = [];
        $('.gift__row').each(function (i) {
            var code = $(this).find('.productBasket__items--item').attr('data-gift-code');
            if (giftCodes.indexOf("|" + code + "|") == -1) CodesToRemove.push(code);
        });
        for (var i = 0; i < CodesToRemove.length; i++) {
            if (CodesToRemove[i] != '') $('.gift__row').find('.productBasket__items--item[data-gift-code="' + CodesToRemove[i] + '"]').remove();
        }

    }
}
function processBasketCommodityCouponItem(json) {
    if ($('.productBasket__items--item.product').length === 0) return;

    var items = json.Coupon;
    var langIdB = json.LangId;

    if (items == null) {
        if ($('.coupon__row').length > 0) $('.coupon__row').remove();
    }
    else {
        ProcessBasketRowCoupon(langIdB, items);
    }
}

function processBasketGA4(json) {
    json.Items.forEach((item) => {
        GA4Scripts["g" + item.ItemId.toString()] = item.GA4dataForAddUpdResult;

        if (item.ItemId == json.RefreshedItem) {
            var event = "add_to_cart";
            var quantity = item.Count - json.RefreshtItemInitialCount;

            if (json.RefreshtItemInitialCount > item.Count) {
                event = "remove_from_cart";
                quantity = json.RefreshtItemInitialCount - item.Count;
            }

            GA4BasketUpd(jQuery.parseJSON(item.GA4dataForAddUpdResult), event, quantity);
        }
    });
}

function processBasketCommoditySum(json) {
    if ($('#basketcommodity').length === 0) return;
    InsertFirstAndSecond($('#basketcommodity .price-product-sum .item--price'), json.sPriceCommodityWithVatWithoutDiscount, json.sPriceCommodityWithVatWithoutDiscountSECOND);
    InsertFirstAndSecond($('#basketcommodity .price-discount-sum .item--price'), json.sDiscount, json.sDiscountSECOND);
    InsertFirstAndSecond($('#basketcommodity .price-round-sum .item--price'), json.sZaokrouhledniCelkoveCeny, json.sZaokrouhledniCelkoveCenySECOND);
    InsertFirstAndSecond($('#basketcommodity .price-producafterdiscount-sum .item--price'), json.sPriceSumWithVatWithoutDeliveryPayment, json.sPriceSumWithVatWithoutDeliveryPaymentSECOND);
      
    if (json.IsDiscount) {
        $('#basketcommodity .price-discount-sum').removeClass('hidden');
    } else {
        $('#basketcommodity .price-discount-sum').addClass('hidden');
    }

    //processRounding(json.IsZaokrouhledniCelkoveCeny, json.sZaokrouhledniCelkoveCeny);

    if (json.IsDiscount/* || json.IsZaokrouhledniCelkoveCeny*/) {
        $('#basketcommodity .price-producafterdiscount-sum').removeClass('hidden');
    } else {
        $('#basketcommodity .price-producafterdiscount-sum').addClass('hidden');
    }

    //progressbar
    $('#basketcommodity .delivery-free-limit').remove();
    if (json.DeliveyProgressBar != "") {
        $(json.DeliveyProgressBar).insertAfter("#basketcommodity .productBasket__itemsInner--suma");
    }
}

// --- step 1 -- levy sloupec

///pravy sloupecek rekapitulace
function processBasketSumContent(json) {
    var prefix = "<small>" + GetTextDynamic("basket_delpaym_price_prefix") + " </small>";
    var basket_delpaym_price_free = '<span class="free">' + GetTextDynamic("basket_delpaym_price_free") + '</span>';
    var basket_payment_price_zero = '<span class="free">' + GetTextDynamic("basket_payment_price_zero") + '</span>';

    InsertFirstAndSecond($('#basketSumPriceBox .price-product-sum'), json.sPriceSumWithVatWithoutDeliveryPayment, json.sPriceSumWithVatWithoutDeliveryPaymentSECOND);

    if (json.Delivery == null) { //doprava neni jasna
        var prefixD = json.PriceDeliveryWithVat > 0 ? prefix : ""; 
        var priceD = json.PriceDeliveryWithVat > 0 ? "<span class='first-prc'>" + json.sPriceDeliveryWithVat + "</span>" + WrapSP(json.sPriceDeliveryWithVatSECOND) : basket_delpaym_price_free;
        var priceDBasketLite = json.PriceDeliveryWithVat + json.PricePaymentWithVat > 0 ? "<span class='first-prc'>" + json.sPriceDeliveryPaymentWithVat + "</span>" + WrapSP(json.sPriceDeliveryPaymentWithVatSECOND) : basket_delpaym_price_free;

        $('#basketSumPriceBox .info--suma__line.delivery .line-name span').remove(); // zrusim pripadny nzev dopravy;
        $('#basketSumPriceBox .info--suma__line.delivery .line-price').html(priceD);

        $('#basketBoxLite .basketBox__prices--item .delivery-value').html(priceDBasketLite);

        if (prefixD != "") {
            $('#basketSumPriceBox .info--suma__line.delivery .line-price span').prepend(prefixD);
            $('#basketBoxLite .basketBox__prices--item .delivery-value span').prepend(prefixD);
        }
    }
    else { //doprava je vybrana
        var priceD = json.Delivery.IsFree ? basket_delpaym_price_free : "<span class='first-prc'>" + json.Delivery.sPriceWithVat + "</span>" + WrapSP(json.Delivery.sPriceWithVatSECOND);                                                                                                           
        var priceDBasketLite = json.Delivery.IsFree && json.PricePaymentWithVat == 0 ? basket_delpaym_price_free : "<span class='first-prc'>" + json.sPriceDeliveryPaymentWithVat + "</span>" + WrapSP(json.sPriceDeliveryPaymentWithVatSECOND);
        $('#basketSumPriceBox .info--suma__line.delivery .line-name span').remove(); // zrusim pripadny nzev dopravy a nasledne pridam novy
        $('#basketSumPriceBox .info--suma__line.delivery .line-name').append('<span>: ' + json.Delivery.Name + '</span>');
        $('#basketSumPriceBox .info--suma__line.delivery .line-name').append('<span class="line-date">' + (json.Delivery.DeliveryDateTextShowInSumPrice ? json.Delivery.DeliveryDateText : "") + '</span>');
        $('#basketSumPriceBox .info--suma__line.delivery .line-price ').html(priceD);

        $('#basketBoxLite .basketBox__prices--item .delivery-value').html(priceDBasketLite);
    }

    if (json.Payment == null) { //platba neni jasna
        $('#basketSumPriceBox .info--suma__line.payment').addClass('hidden');
    }
    else { //platba je vybrana
        var priceP = json.Payment.IsFree ? basket_payment_price_zero : json.Payment.sPriceWithVat + WrapSP(json.Payment.sPriceWithVatSECOND);  

        $('#basketSumPriceBox .info--suma__line.payment .line-name span').remove(); // zrusim  nzev platby a nasledne pridam novy
        $('#basketSumPriceBox .info--suma__line.payment .line-name').append('<span>: ' + json.Payment.Name + '</span>');
        $('#basketSumPriceBox .info--suma__line.payment .line-price').html(priceP);
        $('#basketSumPriceBox .info--suma__line.payment').removeClass('hidden');
    }

    if (json.Delivery != null || json.PriceDeliveryWithVat == 0) prefix = "";
    InsertFirstAndSecond($('#basketSumPriceBox .info--suma__line.line--suma .line-price'), prefix + json.sPriceSumWithVat, json.sPriceSumWithVatSECOND) 

    processRounding(json.IsZaokrouhledniCelkoveCeny, json.sZaokrouhledniCelkoveCeny, json.sZaokrouhledniCelkoveCenySECOND);
}


function processRounding(IsZaokrouhledniCelkoveCeny, price, priceSecond) {
    if (IsZaokrouhledniCelkoveCeny) {
        $('.price-round-sum').each(function (i)
        {
            $(this).removeClass('hidden');
            InsertFirstAndSecond($(this), price, priceSecond);
        })
    } else {
        $('.price-round-sum').each(function (i) { $(this).addClass('hidden'); })
    }
}
function globalRunOnBasket1() {
    PageAction = ($('body').hasClass('body-basket') ? "basket" : "basket-1");
    BindInputCount($('#baskItems_1'));

    //slevovy kupon
    CouponBind();

    //$("#shareBlock form").submit(function (event) {
    //    event.preventDefault();
    //    basketShareSubmitMailForm();
    //});

    //InitInputValidation("#shareBlock .shareCart__form");

    //  v pripade ze url obsahuje priznak pro opakovani obj musim se jej zbavit
    if (window.location.search.indexOf("?ordrrpth") != -1) {
        var obj = { Title: '', Url: window.location.pathname }; history.pushState(obj, obj.Title, obj.Url);
    }
}
 
//kupony 
function CouponBind(): void {

    $('.info--coupon__check').click(function (e) {
        if ($('#basketCouponBlock').hasClass('exists')) return;
        $('#basketCouponBlock').toggleClass('active');
    });

    InitInputValidation('#coupFrm');
    $('#addCoupon').click(function (e) {
        e.preventDefault();

        var $CouponItems = '';
        var form = $(this).closest("form");
        var coupon = form.find('[name=couponCode]');

        // odstraneni mezer
        coupon.val($.trim(coupon.val().toString()));

        var couponType = form.find('[name=couponType]').val();
        var couponCode = coupon.val();

        $('#basketCouponBlock .line2 .alert-input.other').html('').addClass('hidden');

        if (!InputValidationCheck(coupon)) {
            return false;
        }

        var formData = $(form).serialize();
        preloader(true);

        var prms = "";
        if ($vatPayer != null) {
            prms = "&setVAT=" + $vatPayer;
        }

        $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            url: '/ajax/coupon.aspx?action=checkproduct&OneStep=' + $BasketFullPage + prms,
            data: formData,
            success: function (data) {
                try {
                    //console.log(data);
                    //var res = jQuery.parseJSON(data);
                    processBasketJson(data);
                }
                catch (err) {
                    console.log(err);
                }
            },
            complete: function () {
                preloader(false);
            },
            error: function () {
                preloader(false);
                console.log('coupon error ');
            }
        });

    });

    //smazani/odebrani kuponu
    $('.remove_coupon').click(function (e) {
        e.preventDefault();

        $('#basketCouponBlock .line2 .alert-input.other').html('').addClass('hidden');

        CouponDelete();
    });
}

function CouponDelete() {

    preloader(true);

    $.ajax({
        type: 'POST',
        dataType: 'json',
        cache: false,
        url: '/ajax/coupon.aspx?action=dlt&OneStep=' + $BasketFullPage,

        success: function (data) {


            try {

                processBasketJson(data);
            }
            catch (err) {
                $('#basketCouponBlock .line2 .alert-input.other').html(GetTextDynamic('basket_del_coupon_error')).removeClass('hidden');
                console.log(err);
            }


        },
        complete: function () {
            preloader(false);
        },
        error: function () {
            preloader(false);
            $('#basketCouponBlock .line2 .alert-input.other').html(GetTextDynamic('basket_del_coupon_error')).removeClass('hidden');
            console.log('coupon del error ');
        }
    });

}

function PayPalExpressSetVisible() {
    // jsem na strance kosiku - krok dopravy a je v navigaci liste tlacko paypal checkout
    //if ($('input[name="delpaymentP"]').length > 0 && $('.paypal-button-container').length > 0) {
    //    if ($('input[name="delpaymentP"][pet="PayPalExpress"]').length > 0) {
    //        if ($('input[name="delpaymentP"][pet="PayPalExpress"]').is(':checked')) {
    //            $('#buttonnextprew .paypal-button-container').removeClass('hidden');
    //            $('#basketSumPrice .paypal-button-container').removeClass('hidden');
    //            $('#buttonnextprew .next a').hide();
    //            $('.body-basket #BasketClient').hide();
    //            $('.body-basket .basket1Step-title').hide();
    //        }
    //        else {
    //            $('#buttonnextprew .paypal-button-container').addClass('hidden');
    //            $('#basketSumPrice .paypal-button-container').addClass('hidden');
    //            $('#buttonnextprew .next a').show();
    //            $('.body-basket #BasketClient').show(); $('.body-basket .basket1Step-title').show();
    //        }
    //    }
    //}
}

function getBasketShareModal(basketId) {
    preloader(true);
    EshopService("ShareBasket", { 'basketId': basketId }, true, function (result: InfoValueResult) {
        if (result.ErrorLevel == 0) {
            var url = $('#basketUrlBase').val() + result.Value;
            $('#share_link').val(url);
            $('.socialSites-fb').attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + url);
            $('.socialSites-tw').attr("href", "https://twitter.com/intent/tweet?ur=" + url);

            $.fancybox.open({
                src: "#shareBlock",
                opts: {
                    touch: false
                }
            });
        }

        preloader(false);
    });
}
 
//function basketShareToggleMailForm() {
//    if (!$('#shareBlock').hasClass('shareCart__hidden')) {
//        var url = $('#share_link').val().toString();
//        var messagetemplate = $('#shareBlock #messagetemplate').val();
//        var message = messagetemplate.toString().replace('$LINK$', url);

//        $('.shareCart__form #message').val(message);
//        $('#shareBlock').addClass('shareCart__hidden');

//        // validace         
//        InitInputValidation('.shareCart__hidden .shareCart__form');
//    }
//    else {
//        $('#shareBlock').removeClass('shareCart__hidden');
//        OffInputValidation('.shareCart__form');
//    }
//};

//function basketShareSubmitMailForm() {
//    $('#shareBlock #succesmessage').hide();
//    $('#shareBlock #failmessage').hide();

//    var o = $('.shareCart__form');
//    if (!InputValidationCheck($(o).find('input[id="name"]'))) {
//        return false;
//    }
//    if (!InputValidationCheck($(o).find('input[id="emailFrom"]'))) {
//        return false;
//    }
//    if (!InputValidationCheck($(o).find('input[id="emailTo"]'))) {
//        return false;
//    }
//    if (!InputValidationCheck($(o).find('textarea[id="message"]'))) {
//        return false;
//    }

//    preloader(true);

//    var name = $('#shareBlock #name').val().toString();
//    var from = $('#shareBlock #emailFrom').val();
//    var to = $('#shareBlock #emailTo').val();
//    var subject = $('#shareBlock #subject').val().toString().replace('$NAME$', name);
//    var body = $('#shareBlock #message').val();

//    EshopService("EmailSend", { 'from': from, 'to': to, 'subject': subject, 'body': body }, false, function (result: InfoValueResult) {
//        if (result.ErrorLevel == 0) {
//            if (result.Message == "OK") {
//                $('#shareBlock #succesmessage').show();
//            } else {
//                $('#shareBlock #failmessage').show();
//            }
//        }

//        preloader(false);
//        $('#shareBlock .socialSites-email').trigger('click');
//    });
//}

//pokud existuje radek - tak jen aktualizuji pocet, v opacnem pripade zalozim novy radek
function ProcessBasketRowGift(langIdB, row) {
    if ($('.gift[data-gift-code="' + row.Code + '"]').length > 0) {
        $('.gift[data-gift-code="' + row.Code + '"]').find('.inp_count').html(row.Count + ' <small>' + row.Unit + '</small>');
    }
    else {
        var data = { langId: langIdB, id: row.Id, code: row.Code, name: row.Name, image: row.Image, url: row.Url, unit: row.Unit, count: row.Count, price: row.PriceUnitGift, fullBasket: ($BasketFullPage == '1') };
        EshopService("BasketRowGift", data, true, function (result) {

            if (result.ErrorLevel == 0) {
                var res = result.Message;
                $(res).insertAfter('.productBasket__itemsInner.product__row:last');
            }
            else {
                console.error('chyba radku darek!');
            }
        });
    }
}
function ProcessBasketRowCoupon(langIdB, row) {

    var data = { langId: langIdB, urlLangPref: urlLangPrefBasket, id: row.Id, code: row.Code, name: row.Name, image: row.Image, type: row.Type, discount: row.Discount, price: row.PriceWithVatSum, fullBasket: ($BasketFullPage == '1') };
    EshopService("BasketRowCoupon", data, true, function (result) {

        if (result.ErrorLevel == 0) {
            var res = result.Message;
            var o = $('.gift__row').last();
            if (o.length == 0) o = $('.productBasket__itemsInner.product__row:last');
            if ($('.coupon__row').length > 0) $('.coupon__row').remove();
            $(res).insertAfter(o);
        }
        else {
            console.error('chyba radku coupon!');
        }
    });

}
function InsertIfExists(o, htmlValue)
{
    if ($(o).length > 0)
        $(o).html(htmlValue);
}
function InsertFirstAndSecond(obj, htmlFirst, htmlSecond) {
    var s1 = obj.find(".first-prc");
    var s2 = obj.find(".second-prc");

    InsertIfExists(s1, htmlFirst);
    InsertIfExists(s2, htmlSecond);
}
function WrapSP(val) {
    return (val != "" ? "<span class='second-prc'>" + val + "</span>" : "");
}